import { render } from "./InvoicePayment.vue?vue&type=template&id=36da9bde"
import script from "./InvoicePayment.vue?vue&type=script&lang=js"
export * from "./InvoicePayment.vue?vue&type=script&lang=js"

import "./InvoicePayment.vue?vue&type=style&index=0&id=36da9bde&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__